import styled, { css } from 'styled-components';
import { ButtonText } from '../typography';
import { getColor, getColorShade, getSizeBy, getThemeProp } from '../../../src/styled/utils';
const BottomBorderCSS = css `
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  height: ${getSizeBy(0.75)};
  background-color: ${getColor('quaternary')};
  content: '';
`;
export const StyledTabButton = styled.button `
  position: relative;
  height: 100%;
  min-height: ${getSizeBy(6)};
  padding: ${getSizeBy(2.5)} ${getSizeBy(6)};
  background-color: inherit;
  border: 0;
  border-radius: ${getThemeProp('borderRadius')}px;
  outline: 0;
  pointer-events: ${({ disabled }) => disabled && 'none'};

  & > ${ButtonText} {
    color: ${({ disabled, $active }) => {
    if (disabled)
        return getColorShade('onSurface', 'lowEmphasis');
    if ($active)
        return getColor('quaternary');
    return getColorShade('onSurface', 'mediumEmphasis');
}};
  }

  &:focus {
    background-color: ${({ $active, disabled }) => !$active && !disabled && getColorShade('primary', 'pressed')};
  }

  &:hover:not(:focus) > ${ButtonText} {
    color: ${getColor('onSurface')};
  }

  &::after {
    ${({ $active }) => $active && BottomBorderCSS}
  }
`;
